<script>import { twMerge } from 'tailwind-merge';
import { getContext } from 'svelte';
import { get_current_component } from 'svelte/internal';
import { forwardEventsBuilder, useActions } from '../../actions';
export let use = [];
import { exclude } from '../../utils/exclude';
const forwardEvents = forwardEventsBuilder(get_current_component());
const inline = getContext('checkbox-inline');
const name = getContext('checkbox-name');
const defaultClass = 'text-secondary-content text-left stwui-checkbox-description';
$: finalClass = twMerge(defaultClass, $$props.class);
</script>

{#if inline}
	<span
		id="{name}-description"
		class={finalClass}
		use:useActions={use}
		use:forwardEvents
		{...exclude($$props, ['use', 'class'])}
	>
		| <slot /></span
	>
{:else}
	<p
		id="{name}-description"
		class={finalClass}
		use:useActions={use}
		use:forwardEvents
		{...exclude($$props, ['use', 'class'])}
	>
		<slot />
	</p>
{/if}
